
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"124","height":"124"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"width":"124","height":"124","fill":"#400F3F","rx":"16"}}),_c('path',{attrs:{"fill":"#FF4702","d":"M84.814 55.563L68.429 39.137a1.286 1.286 0 00-1.829 0l-6.956 6.973a1.297 1.297 0 000 1.834l1.52 1.55-13.988 5.604a5.162 5.162 0 00-3.195 3.538L38.83 79.452c-.222.879.032 1.81.67 2.453l2.576 2.583a2.573 2.573 0 001.906.749c.205.025.413.025.618 0l20.765-5.165a5.157 5.157 0 003.529-3.1l5.59-14.023 1.546 1.524a1.289 1.289 0 001.829 0l6.956-6.973a1.294 1.294 0 000-1.937zm-20.61 19.395l-15.87 3.951 7.369-7.386c.306-.31.723-.487 1.16-.49a3.87 3.87 0 003.863-3.874c0-2.14-1.73-3.874-3.864-3.874s-3.864 1.734-3.864 3.874c-.004.437-.18.854-.49 1.162l-7.368 7.386 3.994-15.831 16.05-6.431 5.41 5.423-6.39 16.09z"}})])])
          )
        }
      }
    